<template>
  <div class="attendance-group-page">
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button
              type="primary"
              size="medium"
              :icon="buttonType === 'icon' ? 'iconfont icon-tianjiacaidan2' : ''"
              @click="handleAdd"
            >{{ buttonType === 'text' ? '新增' : '' }}</el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form
            size="medium"
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="打卡组名称">
              <el-input
                v-model="searchCondition.name"
                placeholder="请输入打卡组名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="打卡类型">
              <el-select
                v-model="searchCondition.type"
                placeholder="全部"
                clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="固定班制" value="fixed"></el-option>
                <el-option label="排班制" value="scheduling"></el-option>
                <el-option label="自由班制" value="free"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务名称">
              <el-input
                v-model="searchCondition.task_name"
                placeholder="请输入任务名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                v-model="searchCondition.status"
                placeholder="全部"
                clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="有效" :value="1"></el-option>
                <el-option label="无效" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
              <el-button @click="resetSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="tableList"
          :columns="columns"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 1 ? 'success' : 'info'"
                size="small"
              >
                {{ scope.row.status === 1 ? "有效" : "无效" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleView(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <!-- 查看打卡组弹窗 -->
    <el-dialog
      title="查看打卡组"
      :visible.sync="viewDialog.visible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form v-if="viewDialog.data.id" label-position="right" label-width="160px" class="view-form">
        <el-form-item label="打卡组名称:">
          <span>{{ viewDialog.data.group_name || viewDialog.data.name }}</span>
        </el-form-item>
        <el-form-item label="状态:">
          <el-tag :type="viewDialog.data.status === 1 ? 'success' : 'info'" size="small">
            {{ viewDialog.data.status_text || (viewDialog.data.status === 1 ? "有效" : "无效") }}
          </el-tag>
        </el-form-item>
        <el-form-item label="打卡类型:">
          <span>{{ viewDialog.data.attendance_type_text || typeLabel(viewDialog.data.typeFront) }}</span>
        </el-form-item>
        <el-form-item label="打卡组任务:">
          <span v-if="!(viewDialog.data.tasks && viewDialog.data.tasks.length)">—</span>
          <span v-else>
            <span v-for="(t, i) in viewDialog.data.tasks" :key="t.id || i">{{ t.task_name || t.title }}{{ i !== viewDialog.data.tasks.length - 1 ? '、' : '' }}</span>
          </span>
        </el-form-item>
        <template v-if="viewDialog.data.typeFront === 'fixed'">
          <el-form-item label="工作日设置:">
            <div v-if="viewDialog.data.viewDayRows && viewDialog.data.viewDayRows.length" class="view-day-rows">
              <div v-for="r in viewDialog.data.viewDayRows" :key="r.day" class="view-day-row">
                <span class="day-label">{{ r.dayLabel }}:</span>
                <span>{{ r.isRest ? '休息' : (r.shiftName || '—') }}</span>
              </div>
            </div>
            <span v-else>—</span>
          </el-form-item>
          <el-form-item label="法定节假日自动排休:">
            <span>{{ viewDialog.data.holiday_auto_rest ? '是' : '否' }}</span>
          </el-form-item>
        </template>
        <template v-if="viewDialog.data.typeFront === 'scheduling'">
          <el-form-item label="打卡班次:">
            <span v-if="!(viewDialog.data.shifts && viewDialog.data.shifts.length)">—</span>
            <template v-else>
              <span v-for="(s, i) in viewDialog.data.shifts" :key="s.id || i">
                {{ s.shift_name || s.name }}{{ s.attendance_time ? '(' + s.attendance_time + ')' : '' }}{{ i !== viewDialog.data.shifts.length - 1 ? '、' : '' }}
              </span>
            </template>
          </el-form-item>
        </template>
        <template v-if="viewDialog.data.typeFront === 'free'">
          <el-form-item label="工作日:">
            <span>{{ formatWorkDays(viewDialog.data.work_days) }}</span>
          </el-form-item>
          <el-form-item label="法定节假日自动排休:">
            <span>{{ viewDialog.data.holiday_auto_rest ? '是' : '否' }}</span>
          </el-form-item>
          <el-form-item label="工作时长:">
            <span>{{ viewDialog.data.work_hours != null ? viewDialog.data.work_hours + ' 小时' : '—' }}</span>
          </el-form-item>
          <el-form-item label="开始时间:">
            <span>{{ viewDialog.data.work_start_time || '—' }}</span>
          </el-form-item>
          <el-form-item label="结束时间:">
            <span>{{ viewDialog.data.work_end_time_display || '—' }}</span>
          </el-form-item>
        </template>
        <el-form-item label="打卡方式:">
          <span>{{ viewDialog.data.attendance_method === 1 || viewDialog.data.attendance_method === 'location' ? '定位打卡' : '—' }}</span>
        </el-form-item>
        <el-form-item v-if="viewDialog.data.attendance_method === 1 || viewDialog.data.attendance_method === 'location'" label="打卡地点设置:">
          <div v-if="viewDialog.data.tasks && viewDialog.data.tasks.length" class="view-tasks-table">
            <div v-for="(t, i) in viewDialog.data.tasks" :key="t.id || i" class="view-task-row">
              <span class="task-name">{{ t.task_name || t.title || '—' }}</span>
              <span class="task-location">{{ t.workplace || t.work_location || '—' }}</span>
              <span class="task-range">{{ (t.punch_range_m != null ? t.punch_range_m : 500) }}米</span>
            </div>
          </div>
          <span v-else>—</span>
        </el-form-item>
        <el-form-item label="更新时间:">
          <span>{{ viewDialog.data.updated_at || "—" }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 新增/编辑打卡组弹窗 -->
    <el-dialog
      :title="editDialog.title"
      :visible.sync="editDialog.visible"
      width="800px"
      :close-on-click-modal="false"
      @close="handleEditClose"
    >
      <div v-if="editDialog.isEdit && editDialog.isActive" class="edit-tip">
        <i class="el-icon-warning"></i> 次日24:00生效
      </div>
      <el-form
        :model="formData"
        :rules="rules"
        ref="groupForm"
        label-position="right"
        label-width="120px"
        class="attendance-group-form"
      >
        <el-form-item label="打卡组名称:" prop="name" required>
          <el-input
            v-model="formData.name"
            placeholder="请输入打卡组名称"
            style="width: 360px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态:" required>
          <el-switch
            v-model="formData.status"
            :active-value="1"
            :inactive-value="0"
            active-text="有效"
            inactive-text="无效"
          ></el-switch>
        </el-form-item>
        <el-form-item label="打卡组任务:" required>
          <el-button type="primary" size="small" @click="taskDialog.visible = true"
            >设置</el-button
          >
          <el-table
            :data="formData.tasks"
            border
            size="small"
            style="width: 100%; margin-top: 8px; max-width: 480px;"
          >
            <el-table-column prop="task_name" label="任务名称" min-width="120"></el-table-column>
            <el-table-column prop="count" label="人数" width="80" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="handleViewTaskList(scope.row)"
                  >查看名单</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="打卡类型:" prop="type" required>
          <el-radio-group v-model="formData.type" :disabled="editDialog.isEdit" @change="onTypeChange">
            <div class="type-option">
              <el-radio label="fixed">固定班制</el-radio>
              <div class="type-desc">参与该打卡组所有人员上结束时间一致</div>
            </div>
            <div class="type-option">
              <el-radio label="scheduling">排班制</el-radio>
              <div class="type-desc">自定义该打卡组成员的班次</div>
            </div>
            <div class="type-option">
              <el-radio label="free">自由班制</el-radio>
              <div class="type-desc">该打卡组下没有班次设置，随意打卡</div>
            </div>
          </el-radio-group>
        </el-form-item>

        <!-- 固定班制：工作日设置 -->
        <template v-if="formData.type === 'fixed'">
          <el-form-item label="工作日设置:" required>
            <div class="fixed-setting">
              <div class="quick-setting">
                <span class="quick-label">快捷设置：</span>
                <el-input
                  :value="quickShiftLabel"
                  readonly
                  size="small"
                  style="width: 220px; margin-right: 8px;"
                ></el-input>
                <el-button type="primary" size="small" @click="openQuickShiftSelect"
                  >更改班次</el-button
                >
              </div>
              <el-table :data="fixedWorkDayRows" border size="small" style="margin-top: 8px;">
                <el-table-column prop="dayLabel" label="工作日" width="100"></el-table-column>
                <el-table-column label="班次名称" min-width="200">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isRest">休息</span>
                    <span v-else-if="scope.row.shift">{{ scope.row.shift.name }} {{ scope.row.shift.time_desc || '' }}</span>
                    <span v-else class="text-placeholder">—</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="openDayShiftSelect(scope.row.day)">
                      {{ scope.row.isRest ? '设置班次' : '更改班次' }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="holiday-option">
                <el-checkbox v-model="formData.holiday_auto_rest">法定节假日自动排休</el-checkbox>
                <el-button type="text" size="small" @click="openHolidayCalendar">查看法定节假日日历</el-button>
              </div>
            </div>
          </el-form-item>
        </template>

        <!-- 排班制：打卡班次 -->
        <template v-if="formData.type === 'scheduling'">
          <el-form-item label="打卡班次:" required>
            <div class="scheduling-shifts">
              <span class="link-text" @click="openSchedulingShiftSelect">选择班次</span>
              <div v-if="formData.scheduling_shift_ids.length" class="shift-tags">
                <el-tag
                  v-for="item in formData.scheduling_shift_ids"
                  :key="item.id"
                  closable
                  size="small"
                  style="margin-right: 8px; margin-bottom: 4px;"
                  @close="removeSchedulingShift(item.id)"
                >
                  {{ `${item.shift_name}(${item.attendance_time})` }}
                </el-tag>
              </div>
              <span v-else class="text-placeholder">请选择班次</span>
            </div>
          </el-form-item>
        </template>

        <!-- 自由班制：工作日、工作时长、工作时间 -->
        <template v-if="formData.type === 'free'">
          <el-form-item label="工作日:" required>
            <el-checkbox-group v-model="formData.work_days">
              <el-checkbox
                v-for="day in weekDays"
                :key="day.value"
                :label="day.value"
                >{{ day.label }}</el-checkbox
              >
            </el-checkbox-group>
            <div class="holiday-option">
              <el-checkbox v-model="formData.holiday_auto_rest">法定节假日自动排休</el-checkbox>
              <el-button type="text" size="small" @click="openHolidayCalendar">查看法定节假日日历</el-button>
            </div>
          </el-form-item>
          <el-form-item label="工作时长:" prop="work_hours" required>
            <el-input
              v-model.number="formData.work_hours"
              placeholder="请输入"
              type="number"
              min="0"
              style="width: 120px;"
            ></el-input>
            <span class="unit">小时</span>
          </el-form-item>
          <el-form-item label="开始时间:">
            <el-time-picker
              v-model="formData.work_start_time"
              value-format="HH:mm"
              format="HH:mm"
              size="small"
              placeholder="选择开始时间"
              style="width: 120px;"
            />
          </el-form-item>
          <el-form-item label="结束时间:">
            <span class="work-end-time">{{ workEndTimeDisplay }}</span>
          </el-form-item>
        </template>

        <el-form-item label="打卡方式:">
          <el-checkbox v-model="attendanceMethodChecked" disabled>定位打卡</el-checkbox>
        </el-form-item>
        <el-form-item v-if="formData.attendance_method === 'location'" label="打卡地点设置:" required>
          <el-table :data="formData.tasks" border size="small" style="width: 100%; max-width: 560px;">
            <el-table-column prop="task_name" label="任务名称" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.task_name || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="工作地点" min-width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.work_location || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="打卡范围" width="140" align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.punch_range_m"
                  placeholder="请选择"
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="m in PUNCH_RANGE_OPTIONS"
                    :key="m"
                    :label="`${m}米`"
                    :value="m"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialog.visible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleSubmit"
          >确 认</el-button
        >
      </span>
    </el-dialog>

    <!-- 打卡组任务设置弹窗 -->
    <TaskSettingDialog
      :visible.sync="taskDialog.visible"
      :value="formData.tasks"
      @input="formData.tasks = $event"
    />

    <!-- 选择班次弹窗（固定班制-快捷/单日） -->
    <el-dialog
      :title="shiftSelectDialog.title"
      :visible.sync="shiftSelectDialog.visible"
      width="520px"
      append-to-body
      @close="shiftSelectDialog.target = null"
    >
      <el-table
        ref="shiftSelectTable"
        :data="shiftList"
        border
        size="small"
        highlight-current-row
        @current-change="onShiftSelectCurrentChange"
      >
        <el-table-column prop="shift_name" label="班次名称" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.shift_name || scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="attendance_time" label="打卡时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.attendance_time || scope.row.time_desc }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="confirmShiftSelect(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button size="small" @click="shiftSelectDialog.visible = false">取消</el-button>
        <el-button
          v-if="shiftSelectDialog.target && shiftSelectDialog.target.type === 'day'"
          size="small"
          @click="setDayRest(shiftSelectDialog.target.day)"
          >设为休息</el-button
        >
        <el-button size="small" type="primary" @click="confirmShiftSelect(currentShiftRow)">确定</el-button>
      </span>
    </el-dialog>

    <!-- 排班制多选班次弹窗（列表由组件内 getAttendanceGroupShiftOptions 拉取） -->
    <ShiftSelectDialog
      :visible.sync="schedulingShiftDialog.visible"
      :value="formData.scheduling_shift_ids"
      @input="formData.scheduling_shift_ids = $event"
    />

    <!-- 法定节假日日历弹窗 -->
    <el-dialog
      title="法定节假日日历"
      :visible.sync="holidayCalendarVisible"
      width="720px"
      append-to-body
      class="holiday-calendar-dialog"
    >
      <HolidayCalendar />
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import HolidayCalendar from "@/components/HolidayCalendar";
import ShiftSelectDialog from "./components/ShiftSelectDialog";
import TaskSettingDialog from "./components/TaskSettingDialog";
import { mapGetters } from "vuex";

const TYPE_MAP = {
  fixed: "固定班制",
  scheduling: "排班制",
  free: "自由班制",
};
// 接口 attendance_type 转为前端 type
const ATTENDANCE_TYPE_TO_FRONT = { 1: "fixed", 2: "scheduling", 3: "free" };
const FRONT_TYPE_TO_API = { fixed: 1, scheduling: 2, free: 3 };

const WEEK_DAYS = [
  { label: "周一", value: 1 },
  { label: "周二", value: 2 },
  { label: "周三", value: 3 },
  { label: "周四", value: 4 },
  { label: "周五", value: 5 },
  { label: "周六", value: 6 },
  { label: "周日", value: 7 },
];

// 打卡范围可选值（米），默认500
const PUNCH_RANGE_OPTIONS = [100, 150, 200, 250, 300, 350, 400, 450, 500];

export default {
  name: "AttendanceGroup",
  components: { PageHeaderLayout, ApeTable, HolidayCalendar, ShiftSelectDialog, TaskSettingDialog },
  data() {
    return {
      PUNCH_RANGE_OPTIONS,
      weekDays: WEEK_DAYS,
      searchCondition: {
        name: "",
        type: "",
        task_name: "",
        status: "",
      },
      loadingStatus: true,
      columns: [
        {
          title: "打卡组名称",
          value: "group_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "打卡类型",
          value: "attendance_type_text",
          header_align: "center",
          align: "center",
        },
        {
          title: "任务名称",
          value: "task_names",
          header_align: "center",
          align: "center",
        },
        {
          title: "工作日",
          value: "attendance_time_preview",
          header_align: "center",
          align: "center",
        },
        {
          title: "更新时间",
          value: "updated_at",
          header_align: "center",
          align: "center",
        },
      ],
      tableList: [],
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      offset: 0,
      viewDialog: {
        visible: false,
        data: {},
      },
      editDialog: {
        visible: false,
        title: "新增打卡组",
        isEdit: false,
        isActive: false,
      },
      formData: {
        id: null,
        name: "",
        type: "",
        status: 1,
        tasks: [],
        work_days: [],
        holiday_auto_rest: false,
        quick_shift_id: null,
        day_shift_map: {},
        scheduling_shift_ids: [],
        work_hours: null,
        work_start_time: null,
        attendance_method: "location",
      },
      rules: {
        name: [
          { required: true, message: "请输入打卡组名称", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择打卡类型", trigger: "change" },
        ],
      },
      taskDialog: { visible: false },
      shiftList: [],
      shiftSelectDialog: {
        visible: false,
        title: "选择班次",
        target: null,
      },
      schedulingShiftDialog: { visible: false },
      currentShiftRow: null,
      holidayCalendarVisible: false,
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    fixedWorkDayRows() {
      return WEEK_DAYS.map((d) => {
        const day = d.value;
        const val = this.formData.day_shift_map[day];
        const isRest = val === "rest";
        const shiftId = val && val !== "rest" ? val : null;
        const shift = this.getShiftById(shiftId);
        return {
          day,
          dayLabel: d.label,
          isRest,
          shift,
        };
      });
    },
    quickShiftLabel() {
      const s = this.getShiftById(this.formData.quick_shift_id);
      return s ? `${s.name} ${s.time_desc || ""}`.trim() : "";
    },
    attendanceMethodChecked: {
      get() {
        return this.formData.attendance_method === "location";
      },
      set(val) {
        this.formData.attendance_method = val ? "location" : null;
      },
    },
    workEndTimeDisplay() {
      const start = this.formData.work_start_time;
      const hours = this.formData.work_hours;
      if (!start || hours == null || hours === "") return "—";
      const end = this.addHoursToTime(start, Number(hours));
      return end || "—";
    },
  },
  methods: {
    getShiftById(id) {
      if (id == null || id === "") return null;
      return this.shiftList.find((s) => String(s.id) === String(id)) || null;
    },
    typeLabel(type) {
      return TYPE_MAP[type] || type || "-";
    },
    formatWorkDays(days) {
      if (!days || !days.length) return "-";
      const dayMap = {};
      WEEK_DAYS.forEach((d) => (dayMap[d.value] = d.label));
      return days
        .slice()
        .sort((a, b) => a - b)
        .map((d) => dayMap[d] || d)
        .join("/");
    },
    // 开始时间 HH:mm + 小时数 => 结束时间 HH:mm（支持跨天）
    addHoursToTime(timeStr, hours) {
      if (!timeStr || hours == null) return "";
      const [h, m] = String(timeStr).split(":").map(Number);
      const totalMinutes = (h * 60 + (m || 0) + hours * 60) % (24 * 60);
      const h2 = Math.floor(totalMinutes / 60);
      const m2 = totalMinutes % 60;
      return `${String(h2).padStart(2, "0")}:${String(m2).padStart(2, "0")}`;
    },
    getDefaultFormData() {
      return {
        id: null,
        name: "",
        type: "",
        status: 1,
        tasks: [],
        work_days: [],
        holiday_auto_rest: false,
        quick_shift_id: null,
        day_shift_map: {},
        scheduling_shift_ids: [],
        work_hours: null,
        work_start_time: null,
        attendance_method: "location",
      };
    },
    onTypeChange() {
      this.formData.work_days = [];
      this.formData.day_shift_map = {};
      this.formData.quick_shift_id = null;
      this.formData.scheduling_shift_ids = [];
      this.formData.work_hours = null;
      this.formData.work_start_time = null;
    },
    async loadShiftList() {
      const res = await this.$api.getShiftList({ current_page: 1, page_size: 500 });
      const list = res.data || res.list || [];
      this.shiftList = list.map((s) => ({
        ...s,
        name: s.shift_name || s.name,
        time_desc: s.attendance_time || s.time_desc,
      }));
    },
    openQuickShiftSelect() {
      this.shiftSelectDialog.title = "更改班次（快捷设置）";
      this.shiftSelectDialog.target = { type: "quick" };
      this.shiftSelectDialog.visible = true;
      this.$nextTick(() => this.setShiftSelectCurrentRow(this.formData.quick_shift_id));
    },
    openDayShiftSelect(day) {
      this.shiftSelectDialog.title = "更改班次";
      this.shiftSelectDialog.target = { type: "day", day };
      this.shiftSelectDialog.visible = true;
      this.$nextTick(() => this.setShiftSelectCurrentRow(this.formData.day_shift_map[day]));
    },
    setDayShift(day, shiftIdOrRest) {
      this.$set(this.formData.day_shift_map, day, shiftIdOrRest);
    },
    setDayRest(day) {
      this.setDayShift(day, "rest");
      this.shiftSelectDialog.visible = false;
    },
    setShiftSelectCurrentRow(shiftId) {
      if (!this.$refs.shiftSelectTable || !shiftId || shiftId === "rest") return;
      const row = this.getShiftById(shiftId);
      if (row) this.$refs.shiftSelectTable.setCurrentRow(row);
    },
    onShiftSelectCurrentChange(row) {
      this.currentShiftRow = row || null;
    },
    confirmShiftSelect(row) {
      if (!row) return;
      const target = this.shiftSelectDialog.target;
      if (target.type === "quick") {
        this.formData.quick_shift_id = row.id;
        WEEK_DAYS.forEach((d) => {
          if (this.formData.day_shift_map[d.value] !== "rest") {
            this.$set(this.formData.day_shift_map, d.value, row.id);
          }
        });
      } else if (target.type === "day" && target.day !== undefined) {
        this.$set(this.formData.day_shift_map, target.day, row.id);
      }
      this.shiftSelectDialog.visible = false;
    },
    openHolidayCalendar() {
      this.holidayCalendarVisible = true;
    },
    openSchedulingShiftSelect() {
      this.schedulingShiftDialog.visible = true;
    },
    removeSchedulingShift(id) {
      this.formData.scheduling_shift_ids = this.formData.scheduling_shift_ids.filter((x) => (x.id != null ? x.id : x) !== id);
    },
    handleViewTaskList(row) {
      this.$message.info(`查看名单：${row.task_name}（可对接具体接口）`);
    },
    searchButton() {
      this.initList();
    },
    resetSearch() {
      this.searchCondition = {
        name: "",
        type: "",
        task_name: "",
        status: "",
      };
      this.initList();
    },
    async switchPaging() {
      this.initList();
    },
    handleAdd() {
      this.editDialog.title = "新增打卡组";
      this.editDialog.isEdit = false;
      this.editDialog.isActive = false;
      this.formData = { ...this.getDefaultFormData() };
      this.loadShiftList();
      this.editDialog.visible = true;
    },
    async handleView(row) {
      try {
        const res = await this.$api.getAttendanceGroupInfo(row.id);
        const info = res.data || res.info || res;
        const typeFront = ATTENDANCE_TYPE_TO_FRONT[info.attendance_type] || info.type || "";
        const gc = info.group_config || {};
        const weeklyShifts = info.weekly_shifts || [];
        const viewDayRows = typeFront === "fixed" ? WEEK_DAYS.map((d) => {
          const w = weeklyShifts.find((ws) => Number(ws.weekday) === Number(d.value));
          const isRest = w && (w.is_rest === 1 || w.is_rest === true);
          return { day: d.value, dayLabel: d.label, isRest,shift_id: w.shift_id, shiftName: w.shift_name };
        }) : [];
        const workStart = gc.work_start_time || "";
        const workHours = gc.work_duration_hours != null ? gc.work_duration_hours : gc.work_hours;
        this.viewDialog.data = {
          ...info,
          typeFront,
          group_name: info.group_name || info.name,
          attendance_type_text: info.attendance_type_text || TYPE_MAP[typeFront],
          tasks: info.tasks || [],
          viewDayRows,
          holiday_auto_rest: typeFront === "free" ? !!gc.auto_rest_legal_holiday : !!info.auto_rest_legal_holiday,
          work_days: gc.work_days || info.work_days || [],
          work_hours: workHours,
          work_start_time: workStart,
          work_end_time_display: workStart && workHours != null && workHours !== "" ? this.addHoursToTime(workStart, Number(workHours)) : (gc.work_end_time || ""),
        };
        this.viewDialog.visible = true;
      } catch (e) {
        this.$message.error(e.message || "获取打卡组详情失败");
      }
    },
    buildDayShiftMap(typeFront, weeklyShifts, shiftIds) {
      if (typeFront !== "fixed") return {};
      if ((weeklyShifts || []).length) {
        return weeklyShifts.reduce((acc, w) => ({ ...acc, [w.weekday]: w.is_rest ? "rest" : (w.shift_id || "") }), {});
      }
      return (shiftIds || []).length ? WEEK_DAYS.reduce((acc, d) => ({ ...acc, [d.value]: shiftIds[0] }), {}) : {};
    },
    mapTaskFromInfo(t) {
      return {
        id: t.id,
        task_id: t.task_id,
        task_name: t.task_name || t.title || "",
        count: t.member_count != null ? t.member_count : t.count,
        work_location: t.workplace != null ? t.workplace : (t.work_location ?? ""),
        punch_range_m: t.punch_range_m != null ? t.punch_range_m : 500,
      };
    },
    mapShiftFromInfo(s) {
      return { id: s.id, shift_name: s.shift_name || "", attendance_time: s.attendance_time || "", status: s.status != null ? s.status : 1 };
    },
    async handleEdit(row) {
      this.editDialog.title = "编辑打卡组";
      this.editDialog.isEdit = true;
      this.editDialog.isActive = row.status === 1;
      await this.loadShiftList();
      const res = await this.$api.getAttendanceGroupInfo(row.id);
      const info = res.data || res.info || res;
      const typeFront = ATTENDANCE_TYPE_TO_FRONT[info.attendance_type] || info.type || "";
      const gc = info.group_config || {};
      this.formData = {
        ...this.getDefaultFormData(),
        id: info.id,
        name: info.group_name || info.name,
        type: typeFront,
        status: info.status != null ? info.status : 1,
        tasks: (info.tasks || []).map((t) => this.mapTaskFromInfo(t)),
        holiday_auto_rest: typeFront === "free" ? !!gc.auto_rest_legal_holiday : !!info.auto_rest_legal_holiday,
        quick_shift_id: typeFront === "fixed" && (info.shift_ids || []).length ? info.shift_ids[0] : null,
        day_shift_map: this.buildDayShiftMap(typeFront, info.weekly_shifts, info.shift_ids),
        scheduling_shift_ids: typeFront === "scheduling" ? (info.shifts || []).map((s) => this.mapShiftFromInfo(s)) : [],
        work_hours: gc.work_duration_hours != null ? gc.work_duration_hours : gc.work_hours,
        work_start_time: gc.work_start_time || null,
        work_days: gc.work_days || [],
        attendance_method: info.attendance_method === 1 ? "location" : (info.attendance_method || "location"),
      };
      this.editDialog.visible = true;
    },
    validateFormByType() {
      if (this.formData.type === "fixed") {
        const hasAny = Object.keys(this.formData.day_shift_map).some(
          (k) => this.formData.day_shift_map[k] && this.formData.day_shift_map[k] !== "rest"
        );
        if (!hasAny) {
          this.$message.error("请至少为工作日设置一个班次");
          return false;
        }
      }
      if (this.formData.type === "scheduling") {
        if (!this.formData.scheduling_shift_ids.length) {
          this.$message.error("请选择打卡班次");
          return false;
        }
      }
      if (this.formData.type === "free") {
        if (!this.formData.work_days || !this.formData.work_days.length) {
          this.$message.error("请选择工作日");
          return false;
        }
        if (this.formData.work_hours == null || this.formData.work_hours === "") {
          this.$message.error("请输入工作时长");
          return false;
        }
      }
      return true;
    },
    handleSubmit() {
      this.$refs["groupForm"].validate((valid) => {
        if (!valid) {
          this.$message.error("请检查必填项！");
          return;
        }
        if (!this.validateFormByType()) return;
        this.formSubmit();
      });
    },
    async formSubmit() {
      const payload = {
        group_name: this.formData.name,
        status: this.formData.status,
        attendance_type: FRONT_TYPE_TO_API[this.formData.type],
        attendance_method: this.formData.attendance_method === "location" ? 1 : 0,
        task_ids: (this.formData.tasks || []).map((t) => t.task_id).filter(Boolean),
        tasks: (this.formData.tasks || []).map((t) => ({
          task_id:  t.task_id,
          task_name: t.task_name || "",
          member_count: t.count != null ? t.count : 0,
          workplace: t.work_location || "",
          punch_range_m: t.punch_range_m != null ? t.punch_range_m : 500,
        })),
      };
      if (this.formData.id) payload.id = this.formData.id;
      if (this.formData.type === "fixed") {
        payload.shift_ids = this.formData.quick_shift_id ? [this.formData.quick_shift_id] : [];
        payload.weekly_shifts = WEEK_DAYS.map((d) => {
          const val = this.formData.day_shift_map[d.value];
          const is_rest = val === "rest" || val == null || val === "" ? 1 : 0;
          const item = { weekday: d.value, is_rest };
          if (!is_rest && val) item.shift_id = val;
          return item;
        });
      } else if (this.formData.type === "scheduling") {
        payload.shift_ids = (this.formData.scheduling_shift_ids || []).map((s) => s.id != null ? s.id : s);
      } else if (this.formData.type === "free") {
        payload.work_days = this.formData.work_days || [];
        payload.work_duration_hours = String(this.formData.work_hours || "");
        if (this.formData.work_start_time) {
          payload.work_start_time = this.formData.work_start_time;
          payload.work_end_time = this.addHoursToTime(this.formData.work_start_time, Number(this.formData.work_hours) || 0);
        }
        payload.auto_rest_legal_holiday = this.formData.holiday_auto_rest ? 1 : 0;
      }
      const res = await this.$api.saveAttendanceGroup(payload);
      const id = res && (res.data !== undefined ? res.data : (res.id != null ? res.id : res));
      if (id) {
        this.$message.success("保存成功!");
        this.editDialog.visible = false;
        this.initList();
      } else if (res && res.code !== 0) {
        this.$message.error(res.msg || "保存失败");
      }
    },
    handleEditClose() {
      this.$nextTick(() => {
        if (this.$refs["groupForm"]) {
          this.$refs["groupForm"].resetFields();
        }
      });
    },
    async initList(type) {
      this.loadingStatus = true;
      const pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      const params = {
        group_name: this.searchCondition.name || undefined,
        attendance_type: this.searchCondition.type ? FRONT_TYPE_TO_API[this.searchCondition.type] : undefined,
        task_name: this.searchCondition.task_name || undefined,
        status: this.searchCondition.status === "" ? undefined : this.searchCondition.status,
        ...pagingInfo,
      };
      const res = await this.$api.getAttendanceGroupList(params);
      const list = res.data || res.list || [];
      const pages = res.pages || {};
      this.tableList = list.map((item) => ({
        ...item,
        name: item.group_name,
        type: ATTENDANCE_TYPE_TO_FRONT[item.attendance_type],
        type_name: item.attendance_type_text || TYPE_MAP[ATTENDANCE_TYPE_TO_FRONT[item.attendance_type]],
        task_name: item.task_names,
      }));
      this.pagingData.total = pages.total || 0;
      this.offset = pages.offset || 0;
      this.loadingStatus = false;
    },
  },
  mounted() {
    this.initList();
  },
};
</script>

<style lang="scss" scoped>
.attendance-group-page {
  ::v-deep {
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 10px;
    }
    .el-date-editor .el-range-input{
      width: 100%;
    }
    .el-table th {
      line-height: normal;
    }
  }
}
.edit-tip {
  background-color: #fdf6ec;
  border: 1px solid #faecd8;
  color: #e6a23c;
  padding: 8px 16px;
  margin-bottom: 20px;
  border-radius: 4px;
  font-size: 14px;

  .el-icon-warning {
    margin-right: 6px;
  }
}

.attendance-group-form {
  .type-option {
    margin-bottom: 12px;
    .type-desc {
      color: #909399;
      font-size: 12px;
      margin-left: 22px;
      margin-top: 2px;
    }
  }
  .fixed-setting .quick-setting {
    margin-bottom: 8px;
    .quick-label { margin-right: 8px; font-size: 14px; }
  }
  .scheduling-shifts {
    .link-text {
      color: #409EFF;
      cursor: pointer;
      margin-right: 12px;
    }
    .shift-tags {
      display: inline-block;
      margin-top: 4px;
    }
  }
  .holiday-option {
    margin-top: 8px;
    .el-checkbox { margin-right: 12px; }
  }
  .fixed-setting .holiday-option { margin-top: 10px; }
  .unit {
    margin-left: 8px;
    color: #606266;
  }
  .work-end-time {
    color: #606266;
    font-size: 14px;
  }
  .text-placeholder {
    color: #c0c4cc;
  }
}

.view-form {
  .view-day-rows {
    .view-day-row {
      margin-bottom: 4px;
      .day-label { margin-right: 8px; color: #606266; min-width: 36px; display: inline-block; }
    }
  }
  .view-tasks-table {
    .view-task-row {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebeef5;
      &:last-child { border-bottom: none; }
      .task-name { flex: 0 0 140px; }
      .task-location { flex: 1; color: #606266; }
      .task-range { flex: 0 0 60px; color: #909399; font-size: 12px; }
    }
  }
}
</style>
